import { render, staticRenderFns } from "./problem-record-add-or-update.vue?vue&type=template&id=085073a3&scoped=true"
import script from "./problem-record-add-or-update.vue?vue&type=script&lang=js"
export * from "./problem-record-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./problem-record-add-or-update.vue?vue&type=style&index=0&id=085073a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085073a3",
  null
  
)

export default component.exports